import Template from "ui/Template";
import {i18n} from "ui/i18n";
import Tools from "ui/editor/toolboxes/tools/Tools";
import {DISPLAY_MODE_VIEW, DISPLAY_MODE_EDIT} from "ui/canvas/Canvas";
import displayModesView from './display-modes.handlebars';

/**
 * Canvas Display Modes Toolbox
 */
class DisplayModes extends Tools {
	/**
	 * Class constructor
	 *
	 * @param {Object} [options]
	 */
	constructor(options = {}) {
		super(Object.assign({
			title: i18n('title.display-modes'),
			body: new Template(displayModesView)
				.createElement()
		}, options));

		super.setFlag('grid', this.scene.canvas.isGridEnabled());
	}

	/**
	 * Returns selected tool value
	 *
	 * @override
	 * @returns {string}
	 */
	getSelectedTool() {
		if (this.scene.canvas.getDisplayMode() === DISPLAY_MODE_VIEW) {
			return 'view';
		} else {
			return 'edit';
		}
	}

	/**
	 * Sets current tool
	 *
	 * @override
	 * @param {string} name
	 * @returns {void}
	 */
	selectTool(name) {
		if (name === 'view') {
			this.scene.canvas.setDisplayMode(DISPLAY_MODE_VIEW);
		} else {
			this.scene.canvas.setDisplayMode(DISPLAY_MODE_EDIT);
		}
		this.updateSelectedTool();
	}

	/**
	 * Sets flag value
	 *
	 * @override
	 * @param {string} name
	 * @param {boolean} isChecked
	 * @returns {Tools}
	 */
	setFlag(name, isChecked) {
		super.setFlag(name, isChecked);

		if (name === 'grid') {
			this.scene.canvas.enableGrid(isChecked);
		}
		return this;
	}

	/**
	 * Returns flag value
	 *
	 * @param {string} name
	 * @returns {boolean}
	 */
	getFlag(name) {
		if (name === 'grid') {
			return this.scene.canvas.isGridEnabled();
		}
		return super.getFlag(name);
	}
}

export default DisplayModes;
